import type { HTMLAttributes } from 'react';
import React from 'react';

import type { WithClassNameProp, WithDataTestid } from '@vlabs/uikit/types';
import classNames from 'classnames';

import './cell.sass';
import { buildTestid } from '../../../lib/utils';

export type TBuildTableViewCell = (renderable: React.ReactNode) => React.JSX.Element;
export interface BuildTableViewCellProps extends Omit<HTMLAttributes<HTMLDivElement>, 'className'>, WithDataTestid, WithClassNameProp {}

const displayName = 'TableViewCell';
const testid = buildTestid(displayName);

function buildTableViewCell(props: BuildTableViewCellProps | undefined): TBuildTableViewCell {
  function CustomTableViewCell(renderable: React.ReactNode): React.JSX.Element {
    return (
      <div
        {...props}
        {...testid(props?.['data-testid'])}
        className={classNames('TableView__Cell', props?.className)}
      >
        {renderable}
      </div>
    );
  }

  return CustomTableViewCell;
}

export { buildTableViewCell };
